// 保存二维码：仅调用系统文件分享面板，由用户在底部面板中选择保存到相册。
// 不直接下载、不打开新标签页，避免多个保存动作同时触发。
export async function saveImageToAlbum(dataUrl, filename = 'qrcode.png') {
  const data = String(dataUrl || '');
  const mime = data.split(';')[0].split(':')[1] || 'image/png';
  const base64 = data.split(',')[1];
  if (!base64) return false;

  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  const file = new File([new Blob([bytes], { type: mime })], filename, { type: mime });

  if (typeof navigator.share !== 'function' || !navigator.canShare || !navigator.canShare({ files: [file] })) {
    throw new Error('当前浏览器不支持保存面板');
  }

  await navigator.share({ files: [file], title: '二维码' });
  return true;
}

// 保存远程图片（如服务端合成的证券最终图）：先取成 Blob，优先调起系统分享面板（可存相册），
// 不支持文件分享时改为直接下载。返回 'shared' | 'cancelled' | 'download'
export async function saveImageFromUrl(url, filename = 'image.jpg') {
  const token = localStorage.getItem('token');
  const res = await fetch(url, token ? { headers: { Authorization: `Bearer ${token}` } } : undefined);
  if (!res.ok) throw new Error('图片下载失败');
  const blob = await res.blob();
  const mime = blob.type || 'image/jpeg';
  const file = new File([blob], filename, { type: mime });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: filename });
      return 'shared';
    } catch (e) {
      if (e?.name === 'AbortError') return 'cancelled';
    }
  }
  const objUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(objUrl), 800);
  return 'download';
}
